//export const API_BASE_URL = 'http://private-28253c-artclientportalapi.apiary-mock.com';
export const API_BASE_URL = '';
export const URI = {
    config: API_BASE_URL + 'v1/lookup/config',
    hold: API_BASE_URL + 'v1/lookup/hold',
    actionCode: API_BASE_URL + 'v1/action/code/',
    currencyCodes: API_BASE_URL + 'v1/currencyCodes/',
    auth: {
        auth: API_BASE_URL + 'v1/auth',
        username: API_BASE_URL + 'v1/auth/username?username=',
        profile: API_BASE_URL + 'v1/auth/profile',
        menu: API_BASE_URL + 'v1/auth/menu',
        corporate: API_BASE_URL + 'v1/auth/corporate/clients',
        reset: API_BASE_URL + 'v1/password/reset',
        dashboard: API_BASE_URL + 'v1/corporate/{cltCorporateId}/dashboard',
    },
    administration: {
        users: API_BASE_URL + 'v1/users',
        notifications: API_BASE_URL + 'v1/users/reports/{usrId}',
        corporate: {
            users: API_BASE_URL + 'v1/corporate/{cltCorporateId}/users'
        },
        identityManager: API_BASE_URL + 'v1/identity',
        identityMapping: API_BASE_URL + 'v1/clientmap',
        template: API_BASE_URL + 'v1/templates',
        providers: API_BASE_URL + 'v1/users/provider'
    },
    accountManagement: {
        searchConsumer: API_BASE_URL + 'v1/corporate/{cltCorporateId}/search',
        searchAccount: API_BASE_URL + 'v1/corporate/{cltCorporateId}/accounts/search',
        getConsumer: API_BASE_URL + 'v1/consumer',
        getConsumerHistory: API_BASE_URL + 'v1/consumer/{conConsumerId}/history',
        getConsumerPayments: API_BASE_URL + 'v1/corporate/{cltCorporateId}/consumer/{conConsumerId}/payments',
        getConsumerPaymentsById: API_BASE_URL + 'v1/corporate/{cltCorporateId}/consumer/{conConsumerId}/payments/{payPaymentId}',
        getAllAccounts: API_BASE_URL + 'v1/corporate/{cltCorporateId}/consumer/{conConsumerId}/accounts',
        getAccountById: API_BASE_URL + 'v1/corporate/{cltCorporateId}/account/{acoAccountId}',
        statusCode: API_BASE_URL + 'v1/account/statuscode',
        holds: {
            holds: API_BASE_URL + 'v1/corporate/{cltCorporateId}/holds',
            account: API_BASE_URL + 'v1/corporate/{cltCorporateId}/holds/account/{acoAccountId}',
            consumer: API_BASE_URL + 'v1/corporate/{cltCorporateId}/holds/consumer/{conConsumerId}',
        },
        pastsubmission: {
            staging: API_BASE_URL + 'v1/corporate/{cltCorporateId}/accountStaging',
            submitted: API_BASE_URL + 'v1/corporate/{cltCorporateId}/accountStaging/submitted',
            batches: API_BASE_URL + 'v1/corporate/{cltCorporateId}/accountStaging/batches',
        },
        clientAlert: {
            alerts: API_BASE_URL + 'v1/corporate/{cltCorporateId}/alerts',
            upload: API_BASE_URL + 'v1/alerts/upload',
            documents: API_BASE_URL + 'v1/corporate/{cltCorporateId}/account/{acoAccountId}/alerts/document',
            history: API_BASE_URL + 'v1/corporate/{cltCorporateId}/consumer/{conConsumerId}/account/{acoAccountId}/alerts/history'
        },
        documents: API_BASE_URL + 'v1/docutrail/account/{acoAccountId}/documents',
        ediFileUpload: API_BASE_URL + 'v1/corporate/{cltCorporateId}/edi/upload',
        ediFileDownload: API_BASE_URL + 'v1/corporate/{cltCorporateId}/edi/download/{id}'

    },
    cancellation: {
        list: API_BASE_URL + 'v1/corporate/{cltCorporateId}/cancellations',
        cancel: API_BASE_URL + 'v1/corporate/{cltCorporateId}/cancellations/account/{acoAccountId}',
    },
    payments: {
        pending: API_BASE_URL + 'v1/corporate/{cltCorporateId}/payments',
        account: API_BASE_URL + 'v1/corporate/{cltCorporateId}/payment/account/{acoAccountId}',
    },
    report: {
        actuary: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/actuary',
        acknowledgement: {
            report: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/acknowledgement',
            dates: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/acknowledgement/dates',
        },
        cancellation: {
            report: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/cancellation',
            dates: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/cancellation/dates',
        },
        cashflow: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/cashflow',
        payment: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/payment',
        inventory: {
            report: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/inventory',
            searchTemplate: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/inventory/searchTemplate',
        },
        trust: {
            report: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/trust',
            dates: API_BASE_URL + 'v1/corporate/{cltCorporateId}/reports/trust/dates',
        },
        download: API_BASE_URL + 'v1/reports/download'
    },
    mail: {
        mail: API_BASE_URL + 'v1/auth/mail',
        search: API_BASE_URL + 'v1/auth/mail/search',
        mailContent: API_BASE_URL + 'v1/auth/mail/{mailId}',
        saveMail: API_BASE_URL + 'v1/auth/mail',
        unread: API_BASE_URL + 'v1/mail/unread',
        upload: API_BASE_URL + 'v1/mail/upload',
        download: API_BASE_URL + 'v1/mail/download',
        users: API_BASE_URL + 'v1/corporate/{cltCorporateId}/mail/users',

    },
    clientManagement: {
        search: API_BASE_URL + 'v1/client/search',
        clientNAD: API_BASE_URL + 'v1/client/{clientId}/nextActivityDate/',
        clientPutNAD: API_BASE_URL + 'v1/client/{clientId}/nextActivityDate/?nextActDate=',
        corporateNAD: API_BASE_URL + 'v1/corporate/{corporateId}/nextActivityDate',
        clientComments: API_BASE_URL + 'v1/client/{clientId}/comment',
        specialNote: API_BASE_URL + 'v1/client/{clientId}/specialNote',
        clientActions: API_BASE_URL + 'v1/client/{clientId}/clientAction',
        clientCreditManagers: API_BASE_URL + 'v1/client/{clientId}/creditManagers',
    }
}

export const ACCESS_TOKEN = 'token';
export const defaultPageSize = 100;
/** Declared for using in some pop-ups */
export const defaultPageSizeMini = 10;




// WEBPACK FOOTER //
// ./src/app/static/constants.js